// extracted by mini-css-extract-plugin
export default {"asideSection":"AsideSection_asideSection__Mh6v9","disc":"AsideSection_disc__fKd6H"};